(function SearchResults($, HE)
{
	"use strict";

	var PROPERTY_NAME_TOKEN_ALIASES = {
		st    : 'saint',
		saint : 'saint',
		ste   : 'sainte',
		sainte: 'sainte',
		mt    : 'mount',
		mount : 'mount',
		ft    : 'fort',
		fort  : 'fort',
		n     : 'north',
		north : 'north',
		s     : 'south',
		south : 'south',
		e     : 'east',
		east  : 'east',
		w     : 'west',
		west  : 'west',
	};

	function stripPropertyNameAccents(text)
	{
		return text.normalize('NFD').replace(/\p{M}/gu, '');
	}

	function canonicalPropertyNameToken(word)
	{
		var lower = word.toLowerCase();

		return PROPERTY_NAME_TOKEN_ALIASES[lower] || lower;
	}

	function tokenizePropertyName(text)
	{
		var words = stripPropertyNameAccents(text).toLowerCase().trim().replace(/[^\p{L}\p{N}]+/gu, ' ').split(/\s+/).filter(Boolean);

		return words.map(canonicalPropertyNameToken);
	}

	function propertyNameFuzzyMaxDistance(token)
	{
		if (token.length < 5) {
			return 0;
		}

		if (token.length <= 7) {
			return 1;
		}

		return 2;
	}

	function damerauLevenshteinDistance(a, b)
	{
		var lengthA = a.length;
		var lengthB = b.length;
		var matrix = [];
		var i;
		var j;
		var cost;

		if (a === b) {
			return 0;
		}

		if (lengthA === 0) {
			return lengthB;
		}

		if (lengthB === 0) {
			return lengthA;
		}

		for (i = 0; i <= lengthA; i++) {
			matrix[i] = [i];
		}

		for (j = 0; j <= lengthB; j++) {
			matrix[0][j] = j;
		}

		for (i = 1; i <= lengthA; i++) {
			for (j = 1; j <= lengthB; j++) {
				cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;

				matrix[i][j] = Math.min(
					matrix[i - 1][j] + 1,
					matrix[i][j - 1] + 1,
					matrix[i - 1][j - 1] + cost
				);

				if (
					i > 1
					&& j > 1
					&& a.charAt(i - 1) === b.charAt(j - 2)
					&& a.charAt(i - 2) === b.charAt(j - 1)
				) {
					matrix[i][j] = Math.min(matrix[i][j], matrix[i - 2][j - 2] + cost);
				}
			}
		}

		return matrix[lengthA][lengthB];
	}

	function propertyNameTokenFuzzyMatches(filterToken, nameToken)
	{
		var maxDistance = propertyNameFuzzyMaxDistance(filterToken);

		if (maxDistance === 0) {
			return false;
		}

		if (Math.abs(filterToken.length - nameToken.length) > maxDistance) {
			return false;
		}

		return damerauLevenshteinDistance(filterToken, nameToken) <= maxDistance;
	}

	function propertyNameTokenMatchesFilter(filterToken, nameTokens)
	{
		var i;
		var nameToken;

		for (i = 0; i < nameTokens.length; i++) {
			nameToken = nameTokens[i];

			if (nameToken === filterToken) {
				return true;
			}

			if (filterToken.length >= 3 && nameToken.indexOf(filterToken) === 0) {
				return true;
			}

			if (propertyNameTokenFuzzyMatches(filterToken, nameToken)) {
				return true;
			}
		}

		return false;
	}

	function propertyNameMatches(name, filterText)
	{
		var filterTokens = tokenizePropertyName(filterText);
		var nameTokens;
		var i;

		if (!filterTokens.length) {
			return true;
		}

		nameTokens = tokenizePropertyName(name);

		for (i = 0; i < filterTokens.length; i++) {
			if (!propertyNameTokenMatchesFilter(filterTokens[i], nameTokens)) {
				return false;
			}
		}

		return true;
	}

	$(document).ready(function documentReady()
	{
		toggleFilterOverlay(false);

		HE.onload('/Hotels/searchResults/', function onload()
		{
			var $results_map          = $('.hotels-map'),
				$results_list         = $('.search-result-container .results'),
				$results_list_content = $results_list.find('.list-view .content'),
				$nightly_range_label  = $('.nightly-price-range > label'),
				$filtered_count       = $('.option-result-count .filtered'),
				$nightly_price_slider = $('div.multirange-slider'),
				nightly_price_slider  = $nightly_price_slider.get(0),
				results_data_selector = '.search-results .list-view .result-data',
				poi_map               = HE.Web.POIMap(),
				map                   = null;

			var applyPropertyNameFilter = HE.Debounce(function _applyPropertyNameFilter(property_name)
			{
				applySearchResultFilter({
					action      : property_name ? 'set' : 'unset',
					field       : 'property_name',
					value       : property_name,
					single_value: true,
				});
			}, 500);

			$('.mobile-search-section').removeClass('d-none');
			$('.search-section').addClass('d-none');

			$('.search-section-toggle').on('click', function showSearchMobile(e) {
				e.preventDefault();
				$('.search-section').toggleClass('d-none');
			});

			$('.filter-section-toggle').on('click', function showMobileFilters(e) {
				let $div = $('.option-container');
				e.preventDefault();

				$div.toggleClass("d-none")
					.toggleClass("animate__animated animate__fadeInDown");

			});

			$('.filter-option-toggle').on('click', function showOptionSection(e) {
				e.preventDefault();

				$(this).closest('.option-sub-header').siblings('.option-group').toggleClass('d-none');
			});

			$('.map-background').click(function toggleMap() {
				if ($('.map-view ').hasClass('d-none')) {
					$('.map-view ').removeClass('d-none');

					if (map === null) {
						map = new HE.Map($results_map, {
							zoom: 10,
							init: function map_init(_map) {
								_map.populate($(results_data_selector).data('map-markers'));
							}
						});
						map.markerClickCallback     = highlightActiveMarkerListing;
						map.infoWindowCloseCallback = unhighlightActiveMarkerListing;
					}

					$('.map-button').html('Hide Map');
				} else {
					$('.map-view ').addClass('d-none');
					$('.map-button').html('Show Map');

					$('.result.listing.map-view-active').removeClass('map-view-active');
				}
			});

			$results_list.on('click', '.result .view-on-map', function triggerMarker(e)
			{
				var $self           = $(this);
				var viewResultOnMap = function _viewResultOnMap() {
					var marker = map.mapMarkers[$self.data('index')];
					google.maps.event.trigger(marker, 'click');
					map.map.setZoom(16);
					map.map.setCenter(new google.maps.LatLng(marker.lat, marker.lng));
					$("html, body").animate({ scrollTop: 0 }, "fast");
				};

				e.preventDefault();

				if ($('.map-view ').hasClass('d-none')) {
					$('.map-background').click();

					// this is needed to allow the map to load
					setTimeout(function _showAndClick() {
						viewResultOnMap();
					}, 500);
				} else {
					viewResultOnMap();
				}
			});

			$results_list.on('click', '.result .view-pois', function showPOIMap() {
				poi_map.setMainMarker($(this).data('marker'));
			});

			$results_list.on('click', '.result .view-rate-debug', function toggleRateDebug(e) {
				var $link    = $(this),
				$content = $link.parent().next();

				e.preventDefault();

				if ($link.html().includes('fa-plus')) {
					HE.Ajax.get('/Hotels/searchResultsRateDebug/' + $(this).data('giataId'))
					.then(function _getRateDebug(data) {
						$link.html('<small><i class="heicon-minus fas fa-fw fa-minus"></i> Hide Rate Debug Info</small>');

						$content.html(data);
					});
				} else {
					$content.html('');

					$link.html('<small><i class="heicon-plus fas fa-fw fa-plus"></i> Show Rate Debug Info</small>');
				}
			});

			$('.show-amenities-toggle').click(function showAmenities(e) {
				var $self    = $(this),
					text     = $self.data('alt-text'),
					expanded = parseInt($self.data('expanded')),
					opposite = (expanded === 0) ? 1 : 0;

				e.preventDefault();

				$('.side-amenity-list').toggleClass('d-flex');
				$('.side-amenity-list').toggleClass('d-none');
				$self.data('alt-text', $self.html());
				$self.html(text);

				$self.data('expanded', opposite);
			});

			// property name filter
			$('input#property-name').on('keyup cleared', function propertyNameFilter() {
				applyPropertyNameFilter(this.value);
			});

			// toggle listings with amenities
			$(document).on("change", '.amenity-check', function amenityFilter()
			{
				var amenities = [];

				$('.amenity-check:checked').each(function amenitiesParam() {
					amenities.push($(this).val());
				});

				applySearchResultFilter({
					action: 'set',
					field : 'amenity',
					value : amenities,
				});
			});

			// Add Hotel Collections to filter

			$(document).on("change", '#hotel-collection', function collectionFilter()
			{
				var collections = [];
				$('.hotel-collection-check:checked').each(function collectionParam() {
					collections.push($(this).val());
				});
				applySearchResultFilter({
					action: 'set',
					field : 'collections',
					value : collections,
				});
			});

			$('.price-block-check').on('change', function priceBlockFilter()
			{
				adjustPriceSlider();
			});

			// clear all checks for a filter type
			$('.reset-all a').click(function removeChecks(e) {
				var $self       = $(this),
					check_class = '.' + $self.data('checkbox-class');

				e.preventDefault();

				$(check_class).prop('checked', false);

				// trigger change for first checkbox to set off ajax filtering
				$(check_class).eq(0).trigger("change");
			});

			// toggle listings with star ratings
			$('input[type="checkbox"][id^="star-rating"]').change(function ratingFilter()
			{
				let all_checked = [];

				// get all of the star ratings currently checked
				$(".option-star-level:checked").each(function allCheckedStarLevels() {
					all_checked.push($(this).val());
				});

				applySearchResultFilter({
					action: 'set',
					field : 'star_rating',
					value : all_checked,
				});
			});

			$('.specialty-rate-check').on('change', function showByFilter() {
				let all_checked = [];

				// get all of the hotel programs currently checked
				$(".specialty-rate-check:checked").each(function allCheckedHotelPrograms() {
					all_checked.push($(this).val());
				});

				applySearchResultFilter({
					action: 'set',
					field : 'specialty_rate',
					value : all_checked,
				});
			});

			// if "see all from ..." link clicked for a featured property's specialty rate, check the corresponding checkbox and trigger ajax
			$('.featured-specialty-all').on('click', function applySpecialtyFilter() {
				var $self = $(this),
				    rate  = $self.data('rate-code');

				$(".specialty-rate-check").each(function allHotelPrograms() {
					if ($(this).attr("value") === rate) {
						$(this).prop('checked', true);
					} else {
						$(this).prop('checked', false);
					}
				});
				$('.specialty-rate-check').trigger('change');
			});

			$('.specialty-badge').on('click', function _showSpecialtyRateDetails(e) {
				var sabre_hotel_id = $(this).data('sabre-hotel-id'),
					rate_code      = $(this).data('rate-code');

					e.preventDefault();

				$('#ratedetails').offcanvas('show');
				$('#ratedetails-body').html('<div class="text-center"><i class="fa fa-spinner fa-spin fa-3x"></i> Loading rate details...</div>');

				HE.Ajax.get('/Hotels/loadSpecialtyRateDetails/' + encodeURIComponent(sabre_hotel_id) + '/' + encodeURIComponent(rate_code ))
				.then(function content(content) {
					$('#ratedetails-body').html(content);
				});
			});

			$('.featured-collection-filter').on('click', function filterCollectionLink() {
				var val = $(this).attr('data-collection');
				console.log(val, 'value');

				applySearchResultFilter({
					action: 'set',
					field : 'collections',
					value : val,
				});

				$('.hotel-collection-check').each(function checkCollection() {
					if ($(this).val() === val) {
						$(this).prop('checked', true);
					}
				});
			});

			// nightly price range slider config/events
			if (nightly_price_slider) {
				noUiSlider.create(nightly_price_slider, {
					// tooltips: true,
					// step: 10,
					connect: [false, true, false],
					range  : {
						min  : $nightly_price_slider.data('min'),
						'90%': [750],
						max  : $nightly_price_slider.data('max'),
					},
					start: [
						$nightly_price_slider.data('start-min'),
						$nightly_price_slider.data('start-max'),
					],
					format: {
						from: function _sliderFormatFrom(val) {
							return parseInt(val).toFixed();
						},
						to: function _sliderFormatTo(val) {
							return parseInt(val).toFixed();
						},
					},
				});

				nightly_price_slider.noUiSlider.on('update', function updateSliderLabel(values, handle) {
					$nightly_range_label.html('$' + values.join(' - $'));

					sliderCheckBlocks(values);
				});

				nightly_price_slider.noUiSlider.on('set', function _sliderFilter(values, handle)
				{
					applySearchResultFilter({
						action: 'set',
						field : 'nightly_price',
						value : [values[0], values[1]],
					});
				});
			}

			// if price ranges checked, adjust the price slider
			function adjustPriceSlider()
			{
				var min = $nightly_price_slider.data('min'),
					max = $nightly_price_slider.data('max');

				// get the min and max values of price blocks checked so we can adjust the price slider
				$('.price-block-check:checked').each(function getMinMaxForSlider(i) {
					var split = this.value.split("-");

					if (i === 0) {
						min = split[0];
					}

					max = split[1];
				});

				nightly_price_slider.noUiSlider.set([min, max]);
			}

			// when the slider is adjusted, automatically check/un-check price blocks based on the price range
			function sliderCheckBlocks(values)
			{
				var slider_start = values[0],
					slider_stop  = values[1];

				$('.price-block-check').each(function forSlider(i) {
					var $self           = $(this),
						split           = $self.val().split("-"),
						block_min       = parseInt(split[0]),
						block_max       = parseInt(split[1]);

					$self.prop('checked', false);

					// if the checkbox range is entirely within the slider values, check the box
					if ( (block_min >= slider_start) && (block_max <= slider_stop) ) {
						$self.prop('checked', true);
					}

					// only for last iteration. if price block min is less than the slider max, check the box
					if (($('.price-block-check').length - 1) === i) {
						if (block_min < slider_stop) {
							$self.prop('checked', true);
						}
					}
				});

				// handle any price blocks in the middle of other checked blocks.  these should be disabled to indicate you have to accept it
				// since you have outer blocks checked
				$('.price-block-check:checked').each(function innerBlocks(i) {
					var $self      = $(this),
					last_iteration = ($('.price-block-check:checked').length - 1),
					disabled_bool  = false;

					// not the first nor the last iteration of checked blocks
					if ((i > 0) && (i < last_iteration)) {
						disabled_bool = true;
					}

					$self.prop('disabled', disabled_bool);
				});

				// if all checked, it's the same as none checked
				if ($('.price-block-check').length === $('.price-block-check:checked').length) {
					$('.price-block-check').prop('checked', false);
					$('.price-block-check').prop('disabled', false);
				}
			}

			// "clear alls" for various filters that are checkboxes
			function toggleClearAlls()
			{
				var $resets = $('.reset-all');

				$resets.each( function toggleClearAll(i) {
					var $self          = $(this),
						$link          = $self.find('a'),
						checkbox_class = '.' + $link.data('checkbox-class'),
						add_class      = true;                              // assume the "clear all" remains hidden

					// at least one is checked, so show "clear all"
					if ($(checkbox_class + ':checked').length > 0) {
						add_class = false;
					}

					$self.toggleClass('d-none', add_class);
				});
			}

			function updateFilteredCount()
			{
				var filtered_count    = $(results_data_selector).data('filtered-count'),
					hide_star_count   = true,
					hide_result_count = false;

				$filtered_count.toggleClass('d-none', filtered_count === 0);
				$filtered_count.find('.count').html(filtered_count);

				// nothing filtered, so can show counts next to star ratings
				if (filtered_count === 0) {
					hide_star_count = false;
				}
				$('.star-counts').toggleClass('d-none', hide_star_count);

				// if filter(s) applied, dont show "X Properties Found"
				if (filtered_count > 0) {
					hide_result_count = true;
				}
				$('.result-count-content').toggleClass('d-none', hide_result_count);
			}

			function highlightActiveMarkerListing(marker)
			{
				$('.result.listing.map-view-active').removeClass('map-view-active');
				$('.result.listing[data-giata-id="' + marker.giata_id + '"]').addClass('map-view-active');
			}

			function unhighlightActiveMarkerListing(marker) {
				$('.result.listing.map-view-active').removeClass('map-view-active');
				map.viewAllMarkers();
			}

			function refreshAmenities() {
				var show_all = 0;

				// user is currently showing more than the top 10 amenities, so keep it like that
				if (parseInt($('.show-amenities-toggle').data('expanded')) === 1) {
					show_all = 1;
				}

				HE.Ajax.get('/Hotels/refreshAmenities/' + show_all)
				.then(function updateAmenities(results_html)
				{
					$('#amenities-container').html(results_html);
				})
				.catch(function amenitiesError(data) {
					HE.StatusMessage('error', 'Error refreshing amenities');
				});
			}

			function applySearchResultFilter(filter)
			{
				filter.cache_key = $results_list.data('cache-key') || '';

				toggleFilterOverlay(true);

				$("html, body").animate(
					{ scrollTop: 0 }, "fast", function animateComplete() {
						$results_list.addClass('loading');
					}
				);

				toggleClearAlls();

				HE.Ajax.post('/Hotels/filterSearchResults', filter)
				.then(function updateSearchResults(results_html)
				{
					var propertyNameFilter;

					if (results_html.message) {
						throw new Error(results_html.message);
					}

					toggleFilterOverlay(false);

					$results_list_content.html(results_html);
					$results_list.removeClass('loading');
					HE.Web.lazyImages.observe();

					// update filter count
					updateFilteredCount();

					refreshAmenities();
					initPopovers();

					// update map markers
					if (map) {
						map.destroyAllMarkers();
						map.populate($(results_data_selector).data('map-markers'));
					}

					// re-init the collapsable thing
					$('.string-expand-collapse').click(function truncate() {
						var $self      = $(this),
							id         = $self.data("id"),
							$expanded  = $('#expanded_' + id),
							$collapsed = $('#collapsed_' + id);

						if ($expanded.css('display') === 'none') {
							$collapsed.hide();
							$expanded.show();
							$self.attr('src', HE.base_uri + '/images/expand.gif');
						} else {
							$collapsed.show();
							$expanded.hide();
							$self.attr('src', HE.base_uri + '/images/collapse.gif');
						}
					});

					// if we have a property name filter, show the alternate names if they match
					if ($('#property-name').val()) {
						propertyNameFilter = $('#property-name').val();

						$('.alt-name').each(function _loopOverProperties() {
							var altNames = String($(this).data('alt-names') || '').split('|');
							var matches = altNames.some(function _altNameMatches(altName) {
								return propertyNameMatches(altName, propertyNameFilter);
							});

							if (matches) {
								$(this).removeClass('d-none');
							}
						});
					}
				})
				.catch(function filterError(data) {
					$results_list.removeClass('loading');
					HE.StatusMessage('error', data);
					toggleFilterOverlay(false);
				});
			}

			// update on load for consistency
			updateFilteredCount();
			toggleClearAlls();
			initPopovers();
		});

		// gray out the filter inputs while center content loading. necessary so user does not click before page finishes loading
		// probably more of an issue on dev when the debug toolbar is being used
		function toggleFilterOverlay(turn_on)
		{
			$('.option-container').toggleClass('overlay', turn_on);
		}

		// Initialize Bootstrap popover
		function initPopovers() {
			let popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
			popoverTriggerList.map(function popoverTarget(popoverTriggerEl) {
				return new bootstrap.Popover(popoverTriggerEl);
			});
		}
	});
}(jQuery, window.HE || {}));
